<p-panel header="{{ 'PRODUCTOSTRONCAL.LBL_PRODUCTOS' | translate }}" [toggleable]="true" styleClass="panel-simple-verde"
         toggler="header" iconPos="start" [collapsed]="!verDetalle"
         expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-right">
  <div class="grid" *ngIf="carInformacionInicial">
    <div class="col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
    </div>
  </div>

  <div *ngIf="!carInformacionInicial">
    <div class="grid align-items-center mb-4">
      <div class="col-12 md:col-6 lg:col-6" *ngIf="!verDetalle">
        <button type="button" pButton icon="fa fa-plus" class="btn-primary-full"
                label="{{ 'BTN_AGREGAR' | translate }}"
                [disabled]="mostrarAgregar"
                (click)="mostrarPanelAgregar()"></button>
      </div>
      <div class="col-12 md:col-6 lg:col-6 flex justify-content-end" *ngIf="!mostrarAgregar">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')"
               [(ngModel)]="busqueda">
      </div>
    </div>

    <div class="grid" *ngIf="mostrarAgregar" [formGroup]="formulario" style="background: #e7f5ec; border-radius: 8px; padding: 24px; margin: 0 0 20px;">
      <div class="col-12">
        <h3 style="margin-top: 0;">{{ 'PRODUCTOSTRONCAL.LBL_AGREGARPRODUCTO' | translate }}</h3>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTOSTRONCAL.LBL_TIPO' | translate }}</label>
          <p-dropdown [options]="lisTiposProducto" formControlName="idTipoProducto"
                      placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                      optionLabel="label" optionValue="value"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}"></p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTOSTRONCAL.LBL_PRODUCTO' | translate }}</label>
          <p-dropdown [options]="lisProductosDisponibles" formControlName="idProducto"
                      [disabled]="!f.idTipoProducto.value"
                      placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                      filter="filter"
                      optionLabel="label" optionValue="value"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}"></p-dropdown>
          <small class="p-text-secondary" *ngIf="!f.idTipoProducto.value">
            <i class="fa fa-info-circle"></i> {{ 'PRODUCTOSTRONCAL.MSG_SELECCIONETIPOPRIMERO' | translate }}
          </small>
        </div>
      </div>
      <div class="col-12 flex gap-2 mt-2 flex justify-content-center align-items-center">
        <button type="button" pButton class="btn-primary-outline"
                label="{{ 'BTN_CANCELAR' | translate }}"
                (click)="cancelarAgregar()"></button>
        <button type="button" pButton class="btn-primary-full"
                label="{{ 'BTN_GUARDAR' | translate }}"
                (click)="agregar()"></button>
      </div>
    </div>

    <div class="grid mb-4 margin-top: 5rem" *ngIf="mostrarAgregar">
      <div class="col-12 md:col-6 lg:col-6"></div>
      <div class="col-12 md:col-6 lg:col-6 flex justify-content-end">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')"
               [(ngModel)]="busqueda">
      </div>
    </div>

    <p-table #dt [columns]="columnas" [value]="productos" dataKey="idProducto"
             [paginator]="true" [rows]="10" paginatorPosition="bottom"
             styleClass="table-premium tabla-simple-verde">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{ col.header }}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.codigoProducto }}</td>
          <td>{{ row.nombreProducto }}</td>
          <td>{{ row.tipoProducto }}</td>
          <td class="text-center" *ngIf="!verDetalle">
            <button type="button" class="btn-action-premium" icon="fa fa-trash" pButton
                    title="{{ 'BTN_ELIMINAR' | translate }}"
                    (click)="eliminar(row)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{ 'MSG_NOHAYREGISTROS' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</p-panel>

<p-confirmDialog #cd key="eliminarProductoTroncal" [style]="{width: '420px'}" *ngIf="!verDetalle">
  <ng-template pTemplate="footer">
    <button type="button" pButton class="btn-primary-outline"
            label="{{ 'BTN_CANCELAR' | translate }}"
            (click)="cd.reject()"></button>
    <button type="button" pButton class="btn-primary-full" icon="fa fa-trash"
            label="{{ 'BTN_ELIMINAR' | translate }}"
            (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
